import React from 'react'
import PropTypes from 'prop-types'
import Review from '../review'
import { reviewsType } from '../types'

const ReviewList = ({ reviews, color, centreTitle }) => (
  <div role="list" aria-label="List of reviews">
    {reviews.map((review, i) => (
      <Review key={i} color={color} centreTitle={centreTitle} {...review} />
    ))}
  </div>
)

ReviewList.propTypes = {
  reviews: reviewsType.isRequired,
  color: PropTypes.string,
  centreTitle: PropTypes.string,
}

export default ReviewList
